import { useNotification } from '../../../../../hooks'
import { createPipelinePhase } from '../../../../Pipeline'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { RequestProfileTabActivitiesAddPhaseModal } from '../../RequestProfileTabActivitiesAddPhaseModal'
import { useRequestProfileTabActivitiesContext } from '../useRequestProfileTabActivitiesContext'

export function useAddPhaseModal() {
  const { closeModal, handleReload, setModal } =
    useRequestProfileTabActivitiesContext()

  const { requestData } = useRequestProfileContext()

  const { handleAddSuccessNotification } = useNotification()

  // A full reload also fires `onPhasesMetadataChange`, which refreshes the
  // header pipeline — the tab list and the header are loaded independently.
  function handleSuccess() {
    closeModal()
    handleAddSuccessNotification('Notification.PhaseCreatedKey')
    handleReload()
  }

  function handleAddPhase(position) {
    setModal(
      <RequestProfileTabActivitiesAddPhaseModal
        pipelineId={requestData?.pipelineId}
        position={position}
        onClose={closeModal}
        onSubmit={createPipelinePhase}
        onSuccess={handleSuccess}
      />
    )
  }

  return { handleAddPhase }
}
